$(document).ready(function () {
  
  // Restrict quantity input to numbers only
  jQuery(".quantity-input ").keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });
  jQuery(".quantity__input").keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  if(jQuery('.sw--article-slider').length){
      $('.sw--article-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
  }

  if (jQuery('.product_slider_ga').length) {
    jQuery('.product_slider_ga').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.product_slider_thumb',
        infinite: true,
    });

    jQuery('.product_slider_thumb').slick({
        asNavFor: '.product_slider_ga',
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        verticalSwiping: true,
        infinite: true,
        vertical: true,
        responsive: [
            {
                breakpoint: 320, 
                settings: {
                    slidesToShow: 1,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 420, 
                settings: {
                    slidesToShow: 2,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 576, 
                settings: {
                    slidesToShow: 3,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 768, 
                settings: {
                    slidesToShow: 4,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 992, 
                settings: {
                    slidesToShow: 4,
                    vertical: true,
                    verticalSwiping: true,
                }
            },
            {
                breakpoint: 1200, 
                settings: {
                    slidesToShow: 3,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 1400, 
                settings: {
                    slidesToShow: 4,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 1600, 
                settings: {
                    slidesToShow: 4,
                }
            }
        ]
    });
  }

  
  // accordion script
  $(".nav-link").click(function () {
      var target = $(this).attr("data-bs-target");

      // Remove active class from all tabs and hide content
      $(".nav-link").removeClass("active");
      $(".tab-pane").removeClass("show active");

      // Add active class to clicked tab and show corresponding content
      $(this).addClass("active");
      $(target).addClass("show active");
  });

  // Cart Drawer Close on Overlay Click
  jQuery(".cart-drawer__overlay").on("click", function () {
    jQuery(this).parents('.drawer').removeClass('active');
  });

  // AJAX Pagination for Products
  if($('.sw-product-section').length) {
    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      var url = $(this).attr("href");
  
      $.ajax({
        url: url,
        type: "GET",
        beforeSend: function () {
          $("#product-grid").fadeTo(300, 0.5);
        },
        success: function (response) {
          var newContent = $(response).find("#product-grid").html();
          $("#product-grid").fadeTo(200, 0, function () {
            $(this).html(newContent).fadeTo(300, 1);
            initializeAddToCart(); // Reinitialize Add to Cart functionality
            // Scroll to #product-grid after new content loads
            $("html, body").animate({
                scrollTop: $(".sw-product-section").offset().top - 50
            }, 500);
          });
        },
        error: function () {
          alert("Failed to load products. Please try again.");
        }
      });
    });
  }

  // Initialize Add to Cart functionality on page load
  initializeAddToCart();

  function initializeAddToCart() {
    // Quantity Adjustment
    document.querySelectorAll(".quantity-btn").forEach((btn) => {
      btn.addEventListener("click", function () {
        let input = this.parentElement.querySelector(".quantity-input");
        let currentValue = parseInt(input.value);
        if (this.classList.contains("plus")) {
          input.value = currentValue + 1;
        } else if (this.classList.contains("minus") && currentValue > 1) {
          input.value = currentValue - 1;
        }
      });
    });

    // AJAX Add to Cart
    document.querySelectorAll(".ajax-add-to-cart").forEach((form) => {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Prevent Dawn product-form.js from also handling

        let addToCartBtn = this.querySelector(".add-to-cart-btn");
        if (addToCartBtn.dataset.adding === "true") return; // Prevent double-click during add
        addToCartBtn.dataset.adding = "true";

        let formData = new FormData(this);
        let originalHTML = addToCartBtn.innerHTML;

        // Disable button and show loading text
        addToCartBtn.setAttribute("disabled", "true");
        addToCartBtn.textContent = window.cartStrings ? window.cartStrings.addingToCart : "Adding...";

        function restoreButton() {
          addToCartBtn.innerHTML = originalHTML;
          addToCartBtn.removeAttribute("disabled");
          addToCartBtn.removeAttribute("aria-disabled");
          addToCartBtn.classList.remove("loading");
          delete addToCartBtn.dataset.adding;
        }

        setTimeout(function () {
          $("cart-drawer.drawer").addClass("active");
          $("body").addClass("overflow-hidden");
        }, 1500);

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) throw new Error("HTTP " + response.status);
            return response.json();
          })
          .then((data) => {
            addToCartBtn.textContent = window.cartStrings ? window.cartStrings.addedToCart : "Added!";
            setTimeout(restoreButton, 2000);
            updateCartDrawer();
            updateCartCount();
          })
          .catch((error) => {
            console.error("Error adding to cart:", error);
            addToCartBtn.textContent = window.cartStrings ? window.cartStrings.errorAdding : "Error!";
            setTimeout(restoreButton, 2000);
          });
      });
    });
  }

  // Function to refresh Cart Drawer
  function updateCartDrawer() {
    fetch("/cart")
      .then((response) => response.text())
      .then((html) => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, "text/html");
        let newCartDrawer = doc.querySelector(".drawer");

        if (newCartDrawer) {
          let drawerElement = document.querySelector(".drawer");
          drawerElement.innerHTML = newCartDrawer.innerHTML;

          // Remove 'is-empty' class if cart has items
          if (drawerElement.querySelector(".cart-items").children.length > 0) {
            drawerElement.classList.remove("is-empty");
          } else {
            drawerElement.classList.add("is-empty");
          }
        }
      });
  }

  // Function to update cart count
  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        $('.header__icon.header__icon--cart').each(function() {
          var $cartBubble = $(this).find('.cart-count-bubble');
          if ($cartBubble.length) {
            $cartBubble.text(cart.item_count);
          } else {
            $(this).find('.sw--cart-label').after('<div class="cart-count-bubble">'+cart.item_count+'</div>');
          }
        });
      });
  }

});

// Cart Page ajax update value
$(document).on('click change', '.quantity-popover-container .quantity__button, .quantity-popover-container .quantity__input', function () {
    var updatedQuantity = $(this).hasClass('quantity__button') ? 
        $(this).siblings('.quantity__input').val() : $(this).val(); // Get the updated quantity value
    var variantId = $(this).hasClass('quantity__button') ? 
        $(this).siblings('.quantity__input').data('quantity-variant-id') : 
        $(this).data('quantity-variant-id'); // Get the variant ID
    // Prepare the data to be sent in the AJAX request
    var data = {
        updates: {}
    };
    data.updates[variantId] = updatedQuantity; // Update the quantity for the specific variant
    // Send the updated quantity to the cart
    $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: data,
        dataType: 'json',
        success: function (response) {
            //console.log(response); // Log the updated cart data
            // Update div.sw--cart-block content without reloading the page
            $.get(window.location.href, function(data) {
                var updatedContent = $(data).find('div.sw--cart-block').html();
                $('div.sw--cart-block').html(updatedContent);
            });
        }
    });
});

